import routerOptions0 from "/builds/PronounsPage/PronounsPage/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.2_sqlite3@5.1.7__encodin_fdc14ae2a8c7022a4422aaf10251fff5/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/PronounsPage/PronounsPage/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}